import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './styles';
import { PlusIcon } from '../../../../../assets/icons';
import { USER_ROLE_AGENT } from '../../../../../utils/Config/Constants';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../../components/UI/UISearchBar';
import UIController from '../../../../../components/UI/UIController';
import Helmet from 'react-helmet';
import UIModal from '../../../../../components/UI/UIModal';
import CreateUserModal from '../../../../../components/modals/CreateUserModal';
import { AGENTS_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useHistory, useLocation } from 'react-router-dom';
import { getFiltersProp } from '../../../../../redux/selectors/CurrentUserSelectors';
import * as strings from './strings';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_ADMIN_AGENTS } from './queries';
import UILoadingPage from '../../../../../components/UI/UILoadingPage/UILoadingPage';

export default function AdminAgents({}) {
	const QUERY_LIMIT = 25;

	const [agents, setAgents] = useState<UserType[]>();
	const [showCreateAgentModal, setShowCreateAgentModal] = useState<boolean>(false);

	const history = useHistory();
	const filters = useSelector(getFiltersProp);
	const location = useLocation();
	let props = {
		filters,
		location
	};

	let baseVariables = { query: { role: { op_eq: USER_ROLE_AGENT } } };
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, AGENTS_TABLE_TYPE, props, baseVariables);
	const [getAgents, { data: agentsData }] = useLazyQuery(GET_ADMIN_AGENTS, {
		variables
	});

	useEffect(() => {
		(async () => {
			await getAgents();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (agentsData) {
				const fetchedAgents: UserType[] = agentsData['users'];
				setAgents(fetchedAgents);
			}
		})();
	}, [agentsData]);

	const renderTabComponent = () => {
		return (
			<div className='general-header-pin'>
				<UISearchBar type={UI_SEARCH_BAR_TYPES.user} onSearchUpdated={getAgents} className='adminAgentSearch' placeholder={strings.searchBarPlaceholder} />
				<div className='agentFilter--add' onClick={() => setShowCreateAgentModal(true)}>
					<img alt={strings.addButtonAlt} className='agentFilter--add-plus' src={PlusIcon.white} />
				</div>
			</div>
		);
	};

	const renderCreateAgentModal = () => {
		const hideModal = () => {
			setShowCreateAgentModal(false);
		};
		return (
			<UIModal condition={showCreateAgentModal}>
				<CreateUserModal role={USER_ROLE_AGENT} hideModal={hideModal} />
			</UIModal>
		);
	};

	const renderContent = () => {
		if (!agents) return <UILoadingPage />;
		return (
			<>
				{renderTabComponent()}
				<PLTable type={AGENTS_TABLE_TYPE} limit={QUERY_LIMIT} updateTable={getAgents} data={agents} onSelect={(user) => history.push('/agent/' + user.id)} />
				{renderCreateAgentModal()}
			</>
		);
	};
	return (
		<UIController bodyClassName='agentContainer'>
			<Helmet>
				<title>{strings.pageTitle}</title>
				<meta property='og:title' content={strings.pageTitle} />
			</Helmet>
			{renderContent()}
		</UIController>
	);
}
